import { memo } from "react";
import TimezoneAwareClock, {
  TimezoneAwareClockProps,
} from "./timezone_aware_clock";

export { default as TimezoneAwareClock } from "./timezone_aware_clock";
export const MilanTimezoneAwareClock = memo(
  (props: Omit<TimezoneAwareClockProps, "formatOpts">) => (
    <TimezoneAwareClock
      formatOpts={{
        locale: "it-IT",
        timeZone: "Europe/Rome",
      }}
      {...props}
    />
  )
);
